import { render, staticRenderFns } from "./Socialmedia.vue?vue&type=template&id=4e4aa7ff&"
import script from "./Socialmedia.vue?vue&type=script&lang=js&"
export * from "./Socialmedia.vue?vue&type=script&lang=js&"
import style0 from "./Socialmedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports